import styles from './_index.module.scss';

export interface FootnoteProps extends React.HTMLAttributes<HTMLDivElement> {
  header: string;
}

const Footnote = ({ children, header }: FootnoteProps) => {
  return (
    <div className={styles['footnote']}>
      <h3>{header}</h3>
      <div className="wysiwyg">
        <ul>{children}</ul>
      </div>
    </div>
  );
};

export default Footnote;
